import { render, staticRenderFns } from "./FolderRelaunchDialog.vue?vue&type=template&id=668d48de&scoped=true"
import script from "./FolderRelaunchDialog.vue?vue&type=script&lang=js"
export * from "./FolderRelaunchDialog.vue?vue&type=script&lang=js"
import style0 from "./FolderRelaunchDialog.vue?vue&type=style&index=0&id=668d48de&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668d48de",
  null
  
)

export default component.exports